import { render, staticRenderFns } from "./CustomMarker.vue?vue&type=template&id=990ff79e&scoped=true"
import script from "./CustomMarker.vue?vue&type=script&lang=js"
export * from "./CustomMarker.vue?vue&type=script&lang=js"
import style0 from "./CustomMarker.vue?vue&type=style&index=0&id=990ff79e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990ff79e",
  null
  
)

export default component.exports